import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import LogoutIcon from "@mui/icons-material/Logout";
import { useState, useEffect } from "react";
import { Container, Modal, Typography, Box, Grid } from "@mui/material";
import { Text, Card, FormButton } from "../components/UI";
import { CardElement } from "@stripe/react-stripe-js";
import { useController } from "../hooks/useController";
import { APP_SETTINGS } from "../hooks/useAppSettings";
import { useUserData } from "../hooks/useUserData";
import { useNavigate } from "react-router-dom";
import { ChangePassword } from "../components/Layout/ChangePassword";

export const YourAccount = () => {
  const {
    fetchDataAuth: fetchUserInfo,
    response: responseUserInfo,
    data: dataUserInfo,
    error: errorUserInfo,
    isLoading: isLoadingUserInfo,
  } = useController();
  const {
    postDataAuth: cancelAccount,
    response: cancelAccountResponse,
    data: cancelAccountData,
    error: cancelAccountError,
    isLoading: cancelAccountIsLoading,
  } = useController();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [openEditPasswordModal, setOpenEditPasswordModal] = useState(false);
  const [canceledSubscription, setCanceledSubscription] = useState(false);
  const [canceledSubscriptionPopUp, setCanceledSubscriptionPopUp] =
    useState(false);
  const [cancelAccountPopUp, setCancelAccountPopUp] = useState(false);
  const { isAuthenticated, setIsAuthenticated, setToken, token, lang } =
    useUserData();
  const [userInfo, setUserInfo] = useState({
    Email: "",
    SubscriptionStartsOn: "",
  });
  const navigate = useNavigate();

  const logOut = (e) => {
    e?.preventDefault();
    localStorage.clear();
    setToken({});
    setIsAuthenticated(false);
    navigate("/");
  };
  const modalStyle = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const modalStyle2 = {
    position: "absolute",
    top: "30%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 1,
    pt: 1,
    px: 1,
    pb: 1,
    width: "100%",
  };

  const handleOpen = () => {
    setOpenConfirmationModal(true);
  };
  const handleOpenCancelAccountModal = () => {
    setCancelAccountPopUp(true);
  };

  const handleOpenEditPasswordModal = () => {
    setOpenEditPasswordModal(true);
  };

  const handleCloseCancelAccountModal = () => {
    setCancelAccountPopUp(false);
  };
  const handleClose = () => {
    setOpenConfirmationModal(false);
  };
  const cancelSubscription = async (e) => {
    e.preventDefault();

    handleClose();
    setCanceledSubscription(true);
  };

  const cancelAccountHandler = async () => {
      await cancelAccount( `${APP_SETTINGS.api}/Account/DeleteAccount`, token?.access_token);
      
    }
    useEffect(()=>{
        if(cancelAccountResponse?.ok)
        {
          logOut();
        }
    },[cancelAccountData,cancelAccountResponse])

  const changePasswordHandler = (e) => {
    e.preventDefault();
    //navigate('/ChangePassword');
    handleOpenEditPasswordModal();
  };
  useEffect(() => {
    if (canceledSubscription) {
      setCanceledSubscriptionPopUp(true);
    }
  }, [canceledSubscription]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    } else {
      fetchUserInfo(
        `${APP_SETTINGS.api}/Account/UserInfo`,
        token?.access_token
      );
    }
  }, []);

  useEffect(() => {
    console.log(dataUserInfo);
    if (dataUserInfo) setUserInfo(JSON.parse(dataUserInfo)[0]);
  }, [dataUserInfo]);

  useEffect(() => {
    setCanceledSubscription(() => {
      if (userInfo?.SubscriptionStatus != "Active") {
        return false;
      } else return true;
    });
  }, [userInfo]);

  return (
    <>
      <Container fixed>
        <Grid
          xl={12}
          xs={12}
          flexDirection={"row"}
          alignContent={"center"}
          flex={1}
          display={"flex"}
        >
          <Text role="h1" style={{ color: "white" }}>
            {lang?.account}
          </Text>
          <SubscriptionsIcon
            sx={{ color: "white", marginRight: 2 }}
          ></SubscriptionsIcon>

          <Text role="p">
            {lang?.subscribedOn} {userInfo?.SubscriptionStartedOn}
          </Text>
          <a onClick={logOut}>
            <LogoutIcon
              sx={{
                padding: 3,
                backgroundColor: "red",
                color: "white",
                borderRadius: 20,
                marginLeft: 8,
              }}
            ></LogoutIcon>
          </a>
        </Grid>
        <Card role="leftBordered">
        <Text role="h4" style={{ color: "white" }}>
                {lang?.yourEmail}
              </Text>
              <Text role="p" style={{ color: "white" }}>
                {userInfo?.Email}
              </Text>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  alignContent: "center",
                }}
              >
                <FormButton role="secondary" onClick={changePasswordHandler}>
                  {lang?.edit} Password
                </FormButton>
              </Box>
       
          <Grid
            xl={12}
            xs={12}
            flexDirection={"column"}
            alignContent={"center"}
            flex={1}
            display={"flex"}
          >
            {!APP_SETTINGS.isFree ? (
              !canceledSubscription ? (
                <>
                   <Text
            role="h3"
            style={{ color: "white", textTransform: "capitalize" }}
          >
            {lang?.yourSubscription}
          </Text>
                  <Grid
                    item
                    xl={6}
                    xs={12}
                    flexDirection={"column"}
                    alignContent={"center"}
                    flex={1}
                    display={"flex"}
                  >
                    <FormButton onClick={handleOpen} role="primary">
                      {lang?.cancelSubscription}
                    </FormButton>
                    <Text role="p" style={{ color: "white", flex: 4 }}>
                      {lang?.nextPaymentOn}:{" "}
                      {userInfo?.SubscriptionNextPaymentOn}
                    </Text>
                  </Grid>
                </>
              ) : (
                <>
                  <FormButton onClick={handleOpen} role="primary">
                    {lang?.reactivateMembership}
                  </FormButton>
                  <Text role="p" style={{ color: "white", flex: 4 }}>
                    {lang?.yourSubscriptionIsNotActive}
                    10.12.2023
                  </Text>
                </>
              )
            ) : (
              <>
                <FormButton
                  onClick={handleOpenCancelAccountModal}
                  role="primary"
                >
                  {lang?.cancelAccount}
                </FormButton>
              </>
            )}

         
             
           
          </Grid>
        </Card>
       
        {!APP_SETTINGS.isFree && (
           <>
          <hr></hr>
          <Card role="leftBordered">
            <Text
              role="h3"
              style={{ color: "white", textTransform: "capitalize" }}
            >
              {lang?.yourPaymentMethod}
            </Text>
            <Box sx={{ background: "white" }}>
              <CardElement></CardElement>
              <FormButton role="secondary">{lang?.edit}</FormButton>
            </Box>
          </Card>
          </>
        )}
      </Container>
      <Modal
        open={openConfirmationModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {lang?.areYouSureDeleteSubscription}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {lang?.deleteSubscriptionDesc}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <FormButton role="primary" onClick={cancelSubscription}>
              {lang?.yes}
            </FormButton>
            <FormButton role="secondary" onClick={handleClose}>
              {lang?.no}
            </FormButton>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={cancelAccountPopUp}
        onClose={handleCloseCancelAccountModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {lang?.areYouSureDeleteAccount}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {lang?.deleteAccountDesc}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <FormButton role="primary" onClick={cancelAccountHandler}>
              {lang?.yes}
            </FormButton>
            <FormButton
              role="secondary"
              onClick={handleCloseCancelAccountModal}
            >
              {lang?.no}
            </FormButton>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={canceledSubscriptionPopUp}
        onClose={() => {
          setCanceledSubscriptionPopUp(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography role="h2">
            {lang?.yourSubscriptionHasBeenCanceled}
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={openEditPasswordModal}
        onClose={() => {
          setOpenEditPasswordModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle2}>
          <ChangePassword setOpen={setOpenEditPasswordModal}></ChangePassword>
        </Box>
      </Modal>
    </>
  );
};
